import { useNavigate } from "react-router-dom";
import axios from "./customize_axios"

export const saveTokenToLocalStorage = (token) => {
    const expirationTime = Date.now() + 60 * 60 * 1000;
    localStorage.setItem('token', token);
    localStorage.setItem('expirationTime', expirationTime);
};

export const refreshToken = async (token, navigate) => {
    try {
        const response = await axios.post(
            "api/refresh",
            {"token": token},
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        console.log(response.data)
        console.log(response.data.data.token)
        // Lưu lại token mới và thời gian hết hạn
        saveTokenToLocalStorage(response.data.data.token);

        // Gọi lại checkTokenExpiration để tiếp tục theo dõi token sau khi refresh
        checkTokenExpiration(navigate);
    } 
    catch (error) {
        console.error("refreshToken", error.response ? error.response.data : error.message);
        console.error(error.response.data.message) 
        if (error.response.data.message === "Unauthenticated request!") {
            localStorage.removeItem("token");
            localStorage.removeItem("name");
            localStorage.removeItem("role");
            localStorage.removeItem("itemQuantityInCart");
            localStorage.removeItem("expirationTime");
            localStorage.removeItem("activeTab");
            redirectToLogin(navigate)
        }
    }
};

export const checkTokenExpiration = (navigate) => {
    const token = localStorage.getItem('token');
    const expirationTime = localStorage.getItem('expirationTime');

    if (!token || !expirationTime) {
        return;
    }

    const currentTime = Date.now();
    const oneHourInMillis = 60 * 60 * 1000;

    const remainingTime = expirationTime - currentTime;

    if (remainingTime < -oneHourInMillis) {
        // Token đã hết hạn, chuỷen qua trang đăng nhập
        // redirectToLogin(navigate);
        localStorage.removeItem("token");
        localStorage.removeItem("name");
        localStorage.removeItem("role");
        localStorage.removeItem("itemQuantityInCart");
        localStorage.removeItem("expirationTime");
        localStorage.removeItem("activeTab");
    } 
    else if (remainingTime <= 60 * 60 * 1000) {
        // Còn ít hơn 1 giờ, gọi refresh token
        refreshWithTimeout(remainingTime, navigate);
    }
};

const refreshWithTimeout = (remainingTime, navigate) => {
    const refreshInMillis = remainingTime - 5 * 60 * 1000;
    setTimeout(() => {
        const token = localStorage.getItem('token');
        console.log("ủa")
        if (token) {
            refreshToken(token, navigate);
        }
    }, refreshInMillis);
};

export const redirectToLogin = (navigate) => {
    navigate("/login");
};

export const introspective = async (token) => {
    try {
        const response = await axios.post(
            `api/introspect`, 
            { token: token }
        )
        return response.data
    } 
    catch (error) {
        console.log("introspective", error.response ? error.response.data : error.message)
        return []
    }
}